import React from 'react';
import { RegTypes } from 'Types/globals';
import PromoImage from '../../PromoImage/PromoImage';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@spinwise/spinwise-core';
import dynamic from 'next/dynamic';

const PayAndPlayBlock = dynamic(() => import('../../PayAndPlayBlock/PayAndPlayBlock'), { ssr: false });

const Content = ({
  items,
  regtype,
}: {
  items: Array<{ id; title; image; button_text; second_button_text }>;
  regtype?: any;
}) => {
  const geo = useSelector((state: IApplicationState) => state.globalReducer?.geo);

  if (!items) return null;

  if (regtype === RegTypes.PAYPLAY_Z) {
    return <PayAndPlayBlock items={items} />;
  }
  if (regtype === RegTypes.EMAIL) {
    if (['SWE', 'NOR'].includes(geo?.code)) {
      return <PayAndPlayBlock items={items} />;
    } else {
      return (
        <>
          {items.map(el => (
            <PromoImage key={el.id} src={el?.image?.data?.attributes?.url} alt="" />
          ))}
        </>
      );
    }
  }
  return null;
};

export default Content;
